

















































import {Vue, Component, Prop} from 'vue-property-decorator';
import orderDefault from '@/instance-defaults/orderDefault';
import OrderStatusAlert from '@/components/Views/Dashboard/Orders/OrderStatusAlert.vue';
import AdminBookingCard from '@/components/Views/Dashboard/Booking/AdminBookingCard.vue';
import {multiNil, nil, ORDER_STATUS} from '@/common';
import {DateTime} from 'luxon';
import OrderMetadata from '@/components/Views/Dashboard/Orders/OrderMetadata.vue';
import {Mixins} from 'vue-property-decorator';
import CurrencyMixin from '@/mixins/CurrencyMixin.vue';
import CancelOrderDialog from '@/components/Views/Dashboard/Orders/CancelOrderDialog.vue';

@Component({
    components: {
        CancelOrderDialog,
        OrderMetadata,
        AdminBookingCard,
        OrderStatusAlert,
    },
})
export default class OrderOverview extends Mixins(CurrencyMixin) {
    @Prop({default: orderDefault})
    public order!: any;

    public async acceptOrder() {
        this.order.status = ORDER_STATUS.PLACING;
        this.order.save();
    }

    public get noPurchaser() {
        return multiNil(this, 'order.purchaserModel');
    }
    public get noOrder() {
        return multiNil(this, 'order.purchaserModel');
    }
    public get status() {
        if (this.noOrder) { return ORDER_STATUS.ACCEPTED; }
        return this.order.status;
    }
    public get bookingModels() {
        if (this.noOrder) { return []; }
        return this.order.bookingModels;
    }
    public get stripePayment() {
        if (multiNil(this, 'order.stripePaymentObject')) { return {}; }
        return this.order.stripePaymentObject;
    }
    public get customerEmail() {
        if (this.noPurchaser) { return ''; }
        return this.order.purchaserModel.email;
    }
    public get customerPhone() {
        if (this.noPurchaser) { return ''; }
        return this.order.purchaserModel.phone;
    }
    public get refundedGiftCardPayment() {
        if (this.noOrder) { return 0; }
        return this.order.refundedGiftCardPayment;
    }
    public get dateCreated() {
        if (this.noOrder) { return ''; }
        return DateTime.fromISO(this.order.createdAt).toLocaleString(DateTime.DATETIME_MED);
    }
    public get dateUpdated() {
        if (this.noOrder) { return ''; }
        return DateTime.fromISO(this.order.updatedAt).toLocal().toLocaleString(DateTime.DATETIME_MED)
    }
    public get customerConfirmed() {
        if (this.noOrder) { return ''; }
        return this.order.customerEmailed ? 'Yes' : 'No';
    }

    public get servicesTotal() {
        if (this.noOrder) { return 0; }
        return this.order.servicesTotal;
    }
    public get proPaymentTotal() {
        if (this.noOrder) { return 0; }
        return this.order.proPaymentTotal || 0;
    }
    public get proTipTotal() {
        if (this.noOrder) { return 0; }
        return this.order.proTipTotal || 0;
    }
    public get discountTotal() {
        if (this.noOrder) { return 0; }
        return this.order.discountTotal;
    }
    public get giftCardTotal() {
        if (this.noOrder) { return 0; }
        return this.order.giftCardPaymentSubmitted;
    }

}
